
define(
    'jsx!components/ideas-lab/ideas-lab-modal',[
   	"jquery",
	"underscore",
	"backbone",
    "react",
    "shared/connect-to-actions",
	"shared/connect-to-stores",
    "shared/client",
    "actions/ideas-lab",
    "jsx!components/modal/duplicate-buncee",
    "jsx!components/ideas-lab/ideas-lab-detail",
    "shared/browser-detect",
    ], 
    function ($, _, Backbone, React, ConnectToActions, ConnectToStores, Client, IdeasLabAction, DuplicateBunceeModal, IdeasLabDetail, BrowserDetect){
        return React.createClass({
            displayName: "IdeasLabModal",
            getDefaultProps: function ()
            {   
                return {
                    "buncee": "",
                    "closeModal": function () {},
                    "onBookmarkedClick": function () {},
                    "favorites": [],
                };
            },
            getInitialState: function ()
            {  
                return {
                    openLoginContainer: window.appData.user !== null ? false : true,
                }
            },
            componentDidMount: function () {
            },
            handleOverlayClick: function(e) {
                if (e.target.className === "modal-overlay") {
                    this.props.closeModal()
                    e.stopPropagation()
                }
            },
            onCreateThisClick: function() 
            {   
                if (window.appData.user) {
                    this.props.closeModal();
                    var modal = React.createElement(DuplicateBunceeModal, {
                        buncee_guid: this.props.buncee.id,
                        url: this.props.buncee.content.templateURL,
                        trackIdea: function()  {
                            this.props.trackIdea(this.props.buncee.id, "create");
                        }.bind(this)
                    });
                    React.render(modal, document.getElementById('buncee-modal'));
                } else {
                    this.setState({
                        openLoginContainer: true,
                    });
                }
            },
            onBookmarkedClick: function (assetGuid) {
                if (window.appData.user) {
                    var self = this;
                    this.actions = {"ideas-lab" : new IdeasLabAction()};
                    var actionIdeaslab = ConnectToActions["ideas-lab"];
                    actionIdeaslab.updateBookmarked(assetGuid, function (state = false) {
                        if(state) {
                            self.props.trackIdea(assetGuid, "bookmark");
                        }
                        self.props.onBookmarkedClick();
                    });
                } else {
                    this.setState({
                        openLoginContainer: true,
                    });
                }
            },
            onClickLogin: function () {
                window.location = "/login?return_to=/ideas-lab"
            },
            renderPlayer: function() {
                var imageRegex = /\.(jpeg|jpg|gif|png|svg)($|(\?))/i;
                if (this.props.buncee.entity_url.indexOf("bunceeboard") > -1) {
                    if(BrowserDetect.isMobileStrict()) { 
                        return React.createElement("img", {className: "board-content", src: this.props.buncee.thumbnails[0]});
                    } else {
                        return React.createElement("iframe", {id: "buncee-view", src: this.props.buncee.entity_url.replace("buncees", "player") + "?embed=1&render_slide_panel=0", width: "1920", height: "1080", scrolling: "yes", allowFullScreen: true})
                    }
                } else if (this.props.buncee.entity_url.match(imageRegex)) {
                    return React.createElement("img", {className: "image-content", src: this.props.buncee.entity_url});
                } else {
                    var apiLink = this.props.buncee.entity_url.replace(this.props.buncee.entity_url.split(".")[0], this.props.buncee.entity_url.split(".")[0] + ".api");
                    var removeTrailing = apiLink.replace("?", "");
                    return React.createElement("iframe", {id: "buncee-view", src: removeTrailing.replace("/buncee/", "/player/") + "?embed=1&render_slide_panel=0", width: "1920", height: "1080", scrolling: "yes", allowFullScreen: true})
                }
            },
            renderContent: function() {
                if (!this.state.openLoginContainer) {
                    return React.createElement(IdeasLabDetail, {
                        buncee: this.props.buncee, 
                        onCreateThisClick: this.onCreateThisClick, 
                        onBookmarkedClick: this.onBookmarkedClick, 
                        favorites: this.props.favorites, 
                        openFrom: "modal"}
                    )
                } else {
                    return (
                        React.createElement("div", {className: "login-create"}, 
                            React.createElement("div", {className: "login-create-title"}, "Log in to Create"), 
                            React.createElement("div", {className: "login-create-wrapper"}, 
                                React.createElement("div", {className: "back button", onClick: function()  {return this.setState({openLoginContainer: false});}.bind(this)}, "Back"), 
                                React.createElement("div", {className: "login button", onClick: this.onClickLogin}, "Log In")
                            ), 
                            React.createElement("div", {className: "signup-text"}, "Don't have an account? ", React.createElement("a", {href: "/choose-account-type", color: "#00A3A8"}, "Sign Up!"))
                        )
                    );
                }
            },
            render: function ()
            {   
                var self = this;
                return (
                    React.createElement("div", {className: "modal-overlay", onClick: this.handleOverlayClick}, 
                        React.createElement("span", {className: "modal-close-btn icons8-close", onClick: this.props.closeModal}), 
                        React.createElement("div", {className: "ideas-lab-modal modal-type-1"}, 
                            React.createElement("div", {className: "modal-body"}, 
                                React.createElement("div", {className: "embedded-buncee-wrapper"}, 
                                    React.createElement("div", {className: "embedded-buncee"}, 
                                         this.renderPlayer() 
                                    )
                                ), 
                                 this.renderContent() 
                            )
                        )
                    )
                );
            }
        });
    }
);
